<template>
    <div :class="['DropdownWithTrigger', {'DropdownWithTrigger--active': open}]">
        <div class="DropdownWithTrigger__wrapper" v-click-outside="close">
            <div class="DropdownWithTrigger__trigger" @click="toggle">
                <slot name="trigger" :active="open"/>
            </div>
            <div class="DropdownWithTrigger__dropdown" v-if="open">
                <div class="show-mobile">
                    <div class="DropdownWithTrigger__close" @click="close">
                        <BackIcon/>
                        <div class="DropdownWithTrigger__close-text">Вернуться</div>
                    </div>
                </div>
                <slot name="dropdown" :close="close"/>
            </div>
        </div>
    </div>
</template>

<script>

import ClickOutside from 'vue-click-outside';
import BackIcon from '@/assets/image/icons/arrow-left.svg?inline'

export default {
    name: "DropdownWithTrigger",
    components: {
        BackIcon
    },
    data: () => ({
        open: false,
    }),
    methods: {
        toggle() {
            this.open = !this.open;
        },
        close() {
            this.open = false;
        },
    },
    directives: {
        ClickOutside
    }
}
</script>

<style lang="scss">

.DropdownWithTrigger {
  position: relative;

  &--active {
    &::before {
      z-index: 35;
      content: '';
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: $textLightBlack;
      opacity: 0.2;
    }
  }

  &__trigger {
    cursor: pointer;
  }

  &__dropdown {
    position: absolute;
    z-index: 50;
    top: calc(100% + 12px);
    left: 40px;

    background: $white;
    border-radius: 8px;
    box-shadow: $BlockShadow;

    @include mobile {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }

  &__close {
    cursor: pointer;
    background-color: $bg;
    display: flex;
    align-items: center;
    height: 56px;
    padding: 0 16px;
  }

  &__close-text {
    margin-left: 8px;
  }
}

</style>